import React, { Component } from 'react';
import './Payment.css';
import userService from '../../services/user.service'
import CardReactFormContainer from 'card-react';
import AddCardForm from '../add-card-form/AddCardForm';
import Timeline from '../timeline/Timeline'

declare var $;
class Payment extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tip: '',
      countryValue: '',
      error: '',
      total: 0,
      selectedMethod: 'cash',
      cards: [],
      selectedCard: null,
      loading: false,
      products: [],
      cleanProducts: [],
      minProducts: true,
      shippingValue: 0,
      loadingOrder: false,
      comment: '',
      showCardForm: false
    }

    this.changeTip = this.changeTip.bind(this);
    this.changePaymentMethod = this.changePaymentMethod.bind(this);
    this.getUserCards = this.getUserCards.bind(this);
    this.setDefaultCC = this.setDefaultCC.bind(this);
    this.setPaymentData = this.setPaymentData.bind(this);
    this.handleNewCard = this.handleNewCard.bind(this);
    this.changeSelectedCard = this.changeSelectedCard.bind(this);
    this.addDeleteProduct = this.addDeleteProduct.bind(this);
    this.orderProducts = this.orderProducts.bind(this);
    this.changeProductUnits = this.changeProductUnits.bind(this);
    this.verifyProductUnits = this.verifyProductUnits.bind(this)
    this.changeComment = this.changeComment.bind(this)
    this.handleCardForm = this.handleCardForm.bind(this)
    this.stepBack = this.stepBack.bind(this)
    this.openCart = this.openCart.bind(this)
  }

   componentDidMount() {
       $('.chips').material_chip();
     this.setState({
       loadingOrder: false
     })
     this.orderProducts()
     let tip;
     let total = this.props.total
     if(localStorage.getItem('country') === 'co') {
       tip = 1000;
     }
     else {
       tip = 10;
     }
     total = total + tip
     this.setState({
       tip,
       countryValue: tip,
       total
     })
     if(this.props.cc) {
       this.setState({
         selectedMethod: 'cc'
       })
       this.getUserCards()
     }
   }

   componentWillReceiveProps(nextProps) {
     let shippingValue = nextProps.shippingValue
     if(shippingValue) {
       let total = this.state.total;
       total = total + shippingValue
       this.setState({
         shippingValue,
         total
       })
     }
   }


   changeTip(action) {
      let total = parseInt(this.state.total)
      let tip = parseInt(this.state.tip)
      let value = parseInt(this.state.countryValue)
      if(action === 'sum') {
         tip = tip + value;
         total = total + value;
      } else {
        if(tip > 0) {
          tip = tip - value;
          total = total - value;
        }
      }
      this.setState({
        tip,
        total
      })
   }

  changePaymentMethod(selectedMethod) {
     if(selectedMethod === 'cc') {
       this.getUserCards()
     }
     this.setState({
       selectedMethod,
       selectedCard: null
     })
   }

  async getUserCards() {
     this.setState({
       loading: true,
       cards: []
     })
     let cards = await userService.getUserCards()
     if(cards.length > 0) {
       let selectedCard = cards.filter(card => card.default === true)[0]
       this.setState({
         cards,
         loading: false,
         selectedCard
       })
     } else {
       this.setState({
         showCardForm: true
       })
     }

   }

   async setDefaultCC(card) {
     if(this.state.selectedCard) {
       this.state.selectedCard.default = false;
     }
     this.state.selectedCard = [];
     card.default = true;
     let card_reference = card.card_reference
     this.setState({
       selectedCard : card
     })
     let response = await userService.setDefaultCC(card_reference);
   }

   setPaymentData() {
    localStorage.setItem('products', this.state.products);
     this.setState({
       loadingOrder: true
     })
     this.setState({
       cleanProducts: []
     }, ()=> {  this.props.paymentData(this.state) } )
   }

   handleNewCard(event) {
     this.setState({
       showCardForm: false
     })
     this.setDefaultCC(event)
     this.getUserCards()
   }

   changeSelectedCard(card) {
     card.default = !card.default
   }

   addDeleteProduct(product) {
     this.props.changeProduct(product)
   }

   orderProducts() {
     const products = this.props.products
     this.setState({
       products
     })
   }

   changeProductUnits(action , product) {
     let total;
     let original_price
     if(product.original_price) {
       original_price = product.original_price
     } else {
       original_price = product.price
     }
     if(action === 'sum') {
      product.units++;
      if(product.units < 1) {
        total = this.state.total + product.price;
      } else {
        total = this.state.total + parseInt(original_price);
      }
      this.setState({
        total
      })
     } else {
       if(product.units > 0) {
         product.units--;
         if(product.units < 1) {
           total = this.state.total - product.price;
         } else {
           total = this.state.total - parseInt(original_price);
         }
         this.setState({
           total
         })
       }
     }
     if(product.units < 1) {
       product.total_price = 0
     } else {
       product.total_price = 1 * product.price + ( (product.units - 1) * original_price )
     }
     this.verifyProductUnits()
   }

   verifyProductUnits() {
     let units = 0;
     let minProducts
     for(let product of this.state.products) {
       units = units + product.units
     }
     if(units > 0) {
       minProducts = true;
     } else {
       minProducts = false;
     }
     this.setState({
       minProducts
     })
   }

   changeComment(event) {
     this.setState({
       comment: event.target.value
     })
   }

   handleCardForm(action) {
     this.setState({
       showCardForm: action
     })
   }

   stepBack() {
     this.props.continue(true)
   }

   openCart() {
     this.props.cart(true)
   }


  render() {
   let cards = [];
   for(let card of this.state.cards) {
     cards.push(
       <div className={"cc animated zoomIn row " + (card.default ? 'active' : 'inactive')} key={card.card_reference} onClick={() => this.setDefaultCC(card)}>
             <div className="col s12 description-card">
               <i className="fa fa-credit-card" aria-hidden="true"></i>  **********{card.termination}
             </div>
       </div>
     )
   }

   let products = [];
   let original_price;
   let original = false
   for (let product of this.state.products) {
     if(product.original_price) {
       original_price = product.original_price;
       original = true;
     } else {
       original_price = product.price
     }
     products.push(


       <li className="collection-item avatar" key={product.id}>
         <img src={product.image} alt="" className="circle"/>
         <span className="title truncate">{product.name}</span>
      { original &&   <p> {( parseInt(original_price) !== product.price ) && <span> ${product.original_price}</span> } ${product.total_price}
         </p> }
         {!original && <p> ${product.total_price}</p>  }
          <a className="secondary-content qty">
            <span onClick={() => this.changeProductUnits('less', product)}>  - </span>
            <span> {product.units} </span>
            <span onClick={() => this.changeProductUnits('sum', product)}>+ </span>
         </a>
       </li>

     )
    }
    return (
      <div>
    { this.state.showCardForm && <AddCardForm added={this.handleNewCard.bind(this)}  show={this.handleCardForm.bind(this)}></AddCardForm> }
    {!this.state.showCardForm &&
    <div id="payment">
      <header>
      <nav>
       <div className="nav-wrapper no-color">
         <a  className="brand-logo center">Confirma tu pedido</a>
         <a onClick={this.stepBack} className="button-collapse"><i className="material-icons">keyboard_arrow_left</i></a>
        { /* <ul id="nav-mobile" className="right">
           <li><a onClick={this.openCart}><i className="material-icons cart">shopping_basket</i></a></li>
         </ul>  */ }
       </div>
      </nav>

     <Timeline confirmation="true"></Timeline>
  </header>
        {this.props.showProducts &&
             <ul className="collection">
             {products}
             </ul>
        }

            <div className="row container">
                 <div className="col s6">  <p> Valor del servicio:</p>  </div>
                 <div className="col s6 center">   <p> <span>${this.state.shippingValue}</span></p>  </div>
            </div>
                <div className="row tips container">
                          <div className="col s6">  <p> Propina:</p>  </div>
                          <div className="col s6 center">
                      <a className="secondary-content qty">
                        <span onClick={() => this.changeTip('less')}>  - </span>
                        <span> {"$" + this.state.tip} </span>
                        <span onClick={() => this.changeTip('sum')}>+ </span>
                      </a>
                        </div>

                </div>
                <div className="row container">
                  <div className="col s6">  <p  className="total" >Total:</p>  </div>
                  <div className="col s6 center">   <p> <span className="subtotal">${this.state.total}</span></p>  </div>
                </div>
                <div className="row container">
                  <div className="col s6">     <p >Método de Pago</p> </div>
                </div>
                  <div className="row container center">
                    { !this.props.cc &&
                    <div className="col s6">
                    <div className={"chip " + (this.state.selectedMethod !== 'cash' ? 'inactive' : 'active')} onClick={()=> this.changePaymentMethod("cash")}>
                         Efectivo
                    </div>
                    </div> }
                    <div className="col s6">
                    <div className={"chip " + (this.state.selectedMethod === 'cash' ? 'inactive' : 'active')} onClick={()=> this.changePaymentMethod("cc")}>
                        T. de Credito
                    </div>
                    </div>


                  </div>




         { this.state.selectedMethod === 'cc' &&
           <div className="cards row center" >
             <div className="col s12">
            { this.state.loading &&
              <div className="preloader-wrapper small active">
      <div className="spinner-layer spinner-green-only">
        <div className="circle-clipper left">
          <div className="circle"></div>
        </div><div className="gap-patch">
          <div className="circle"></div>
        </div><div className="circle-clipper right">
          <div className="circle"></div>
        </div>
      </div>
    </div>}
             {cards}
            { !this.state.loading  &&
             <a className="waves-effect waves-teal btn-flat" onClick={()=> this.handleCardForm(true)}>Agregar tarjeta</a>}

            </div>
            </div>
          }

        <div className="row container">
          <div className="input-field col s12">
              <textarea id="textarea1" className="materialize-textarea" value={this.state.value}  onChange={this.changeComment}></textarea>
              <label htmlFor="textarea1">¿Quieres algo más?</label>
          </div>
        </div>
        { this.props.error !== '' &&     <p className="error animated tada center">{this.props.error}</p>  }
        <div className="action center container">
          {(this.state.loadingOrder && this.props.error === '') && <div className="progress">
              <div className="indeterminate"></div>
          </div> }
          { (!this.state.loadingOrder || this.props.error !== ''  )  && <a className={"btn order btn-orange waves-effect waves-light " + ( ( (!this.state.selectedCard && (this.state.selectedMethod === 'cc') ) || !this.state.minProducts  )? 'disabled' : 'enable')}  onClick={this.setPaymentData} >Hacer Pedido</a> }
          { (this.state.loadingOrder && this.props.error === '') && <a className="btn order btn-orange waves-effect waves-light disabled" >Procesando...</a> }
        </div>
        { this.props.loadingOrder  &&  <p className="waiting animated pulse text-center container">Aún estamos procesando tu orden. Esto puede tardar unos segundos...</p>  }
        </div> }
        </div>

    );
  }
}


export default Payment;



// WEBPACK FOOTER //
// ./src/components/payment/Payment.js